import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({
  element: Component,
  requiredStatus,
  redirectTo,
  enforcePaidStatus = true,
}) => {
  const location = useLocation();
  const roleId = Number(localStorage.getItem("role_id"));
  const subscriptionEndDate = localStorage.getItem("subscription_end_date");
  const hasValidSubscription =
    !subscriptionEndDate ||
    new Date(subscriptionEndDate).getTime() >= Date.now();
  const isPaidUser =
    localStorage.getItem("isPaidUser") === "true" && hasValidSubscription;
  const appUserAllowedPaths = [
    "/patient/Dashboard",
    "/patient/Health_Tracker",
    "/patient/Garbha_Sanskar",
    "/patient/Contact",
    "/patient/profile",
  ];

  if (roleId === 4 && !isPaidUser) {
    return <Navigate to="/tracker-user" />;
  }

  if (roleId === 4 && !appUserAllowedPaths.includes(location.pathname)) {
    return <Navigate to="/patient/Garbha_Sanskar" />;
  }

  if (!enforcePaidStatus) {
    return <Component />;
  }

  return isPaidUser === requiredStatus ? (
    <Component />
  ) : (
    <Navigate to={redirectTo} />
  );
};

export default ProtectedRoute;
